import React, { Component } from "react";
import { Graphics } from "./components/Graphics";
import { MoveMenu } from "./components/MoveMenu";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../Dialogs/toast/Toast";

import "./style.scss";

import {WhiteHamburgerIcon} from '@learningblocks/storybook-components/lib/Icons';
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

export class Solution extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    const interactions = (heldObj, target) => {
      const solutionTubeIsNotHeld = heldObj.type !== "Solution" || heldObj.id !== this.props.id;
      const targetIsUndefined = target === undefined || target === null;

      if (solutionTubeIsNotHeld || targetIsUndefined) {
        return null;
      }

      if (target.type === "Microcentrifuge") {
        this.toMicrocentrifuge(target, heldObj);
      }
      if (target.type === "FloatingTubeRack") {
        this.toFloatingTubeRack(target, heldObj);
      }
      if (target.type === "IceBucket") {
        this.toIceBucket(target, heldObj);
      }
    };

    Object.defineProperty(interactions, "name", {
      value: "solution_interactions_" + this.props.id,
      configurable: true,
    });
    this.props.pushInteractions([interactions]);
  }

  makeToast = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px",
      }),
      progressClassName: css({
        background: color,
      }),
      position: "top-center",
      autoClose: 5000,
    });
  };

  toggleClosed = () => {
    this.props.solutionOpen({
      id: this.props.id,
      open: !this.props.open,
    });
  };

  showControls = () => {
    this.props.hideAllControls();
    this.props.setSolutionControlVisibility({
      id: this.props.id,
      controlsVisible: true,
    });
  };

  solutionSelected = () => {
    if (!this.props.controlsVisible) {
      this.showControls();
    }

    this.props.setSolutionHeld({
      id: this.props.id,
      held: true,
    });
  };

  solutionUnselected = () => {
    this.props.setSolutionHeld({
      id: this.props.id,
      held: false,
    });
  };

  showMoveMenu = (e) => {
    // this.props.setMoveMenu({
    //   type: this.props.type,
    //   connect: this.props.id
    // });
    // this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
  };

  removeFromScene() {
    if (this.props.onIce) {
      this.props.removeTubeFromIceBucket({
        id: this.props.onIce,
        solutionId: this.props.id,
      });

      this.props.setSolutionOnIce({
        id: this.props.id,
        onIce: null,
      });

      this.props.setSolutionInScene({
        id: this.props.id,
        inScene: false
      });

    } else {
      this.props.setSolutionInScene({
        id: this.props.id,
        inScene: false
      });
    }
  }

  removeFromIce() {
    this.props.removeTubeFromIceBucket({
      id: this.props.onIce,
      solutionId: this.props.id,
    });

    this.props.setSolutionOnIce({
      id: this.props.id,
      onIce: null,
    });

    this.props.setSolutionInScene({
      id: this.props.id,
      inScene: false,
    });
  }

  resetTubePosition(heldObj){
    heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)";
  }

  resetTubePositionAndZindex(heldObj){
      heldObj.htmlObj.style.transform =
        "translate3d(0px,0px,0px) rotateZ(0deg)";
      heldObj.htmlObj.style.zIndex = null;
  }

  toIceBucket(target, heldObj) {
    const alreadyOnIce = this.props.onIce !== null;
    if(alreadyOnIce){
      this.resetTubePositionAndZindex(heldObj)
      this.props.hideAllControls();
      return;
    }

    // const iceBucketIsFull = this.props.interactionProps.iceBuckets[target.id - 1].solutions.filter((solution) => solution.id !== null).length < 6
    // if (iceBucketIsFull) {
    //   this.resetTubePositionAndZindex(heldObj)
    //   this.makeToast( "WARNING", "This ice bucket currently contains the maximum number of solutions.", "Ice bucket full!" );
    //   this.props.hideAllControls();
    //   return
    // }

    this.props.setSolutionOnIce({
      id: this.props.id,
      onIce: target.id,
    });

    this.props.setSolutionInScene({
      id: this.props.id,
      inScene: false,
    });

    this.props.addTubeToIceBucket({
      id: target.id,
      solutionId: this.props.id,
      type: this.props.type,
    });
  }

  toFloatingTubeRack(target, heldObj) {
    const floatingTubeRackIsFull = this.props.interactionProps.floatingTubeRack[target.id - 1].count >= 8;
    if (floatingTubeRackIsFull) {
      this.resetTubePosition(heldObj)
      this.makeToast(
        "WARNING",
        "You cannot fit more tubes on the tube rack.",
        "Tube Rack is Full!"
      );
      return
    }

      const solutionTubeProps = {
        size: this.props.defaultProps.size,
        type: this.props.defaultProps.type,
        solutionColor: this.props.defaultProps.solutionColor,
        circleColor: this.props.defaultProps.circleColor,
        circleOutline: this.props.defaultProps.circleOutline,
        label: this.props.defaultProps.label,
        originTubePosition: this.props.defaultProps.originTubePosition
      };

      this.removeFromScene();

      //Add this solution to Floating Rack array
      this.props.addTubeToRack({
        solution: solutionTubeProps,
        type: this.props.type,
        id: this.props.id
      });

      //let floatingRackPos = document.getElementById("FloatingTubeRack_" + 1).getBoundingClientRect();
      //let elemPos = heldObj.htmlObj.parentNode.parentNode.getBoundingClientRect();

      //let deltaLeft = (floatingRackPos.left - elemPos.left);
      //let deltaTop = (floatingRackPos.top - elemPos.top);

      //let index = this.props.interactionProps.floatingTubeRack[0].tubes.find(function (val) {
        //return (val === null);
      //}); 

      //let positions = [30, 55, 85, 110];
      // heldObj.htmlObj.style.transform = "translate3d(" + (deltaLeft + positions[index]) + "px, " + (deltaTop + 33) + "px, 0px) rotateZ(0deg)";
      this.resetTubePosition(heldObj)

  }

  toMicrocentrifuge(target, heldObj) {
    const targetMicrocentrifuge = this.props.interactionProps.microcentrifuge[target.id - 1];
    if (!targetMicrocentrifuge.isOpen) {
      this.resetTubePosition(heldObj);
      this.makeToast("WARNING", "You must open the microcentrifuge first.", "Microcentrifuge is closed!");
      return;
    }

    if (this.props.open) {
      this.resetTubePosition(heldObj);
      this.makeToast("WARNING", "Please close the solution tube", "Solution tube open");
      return;
    }

    let openRotorSlotArr = targetMicrocentrifuge.slots.filter(slot => slot.rotor && slot.solutionId === null);
    if (openRotorSlotArr.length < 1 && this.props.size === 'sm') {
      this.resetTubePosition(heldObj);
      this.makeToast("WARNING", "You need to ensure there is an empty rotor slot in order to add this tube to the microcentrifuge.", "No open rotor slots!");
      return
    }

    this.removeFromScene();

    this.props.onMicrocentrifugeInsertItem({
      
      id: target.id,
      itemId: this.props.id,
      tubeType: (this.props.size === "sm") ? "PCR" : "NON_PCR",
      defaultProps: {
        originTubePosition: this.props.defaultProps?.originTubePosition,
        type: this.props.type
      }

    });
    this.resetTubePosition(heldObj)
  }


  componentWillMount() {
    if (this.props.defaultProps.type === "Extracted Human DNA") {
      let props = this.props.defaultProps;

      let items = ["DNA A", "DNA B", "DNA C"];

      props.solutions = {
        [items[
          Math.floor(
            Math.random() *
            (this.props.levelSelected.id === 1
              ? items.length - 1
              : items.length)
          )
        ]]: this.props.defaultProps.solutions["Extracted Human DNA"],
      };

      this.props.createSolution({
        props: props,
      });
    } else {
      this.props.createSolution({
        props: this.props.defaultProps,
      });
    }
  }

  componentDidMount() {
    window.setTimeout(() => {
      this.movemenu.style.bottom =
        "calc(100% + " + this.label.offsetHeight + "px)";
    }, 2000);
  }
  getLabel = () => {
    const { labelReactionTubes, renamable, solutionAlias, fullName } = this.props
    if (!labelReactionTubes && renamable) {
      return solutionAlias
    }
    return fullName
  }
  render() {
    return (
      <ul
        style={{
          visibility: !this.props.inScene ? "hidden" : null,
          zIndex: this.props.controlsVisible ? 99 : null,
        }}
      // !this.props.labelReactionTubes ? this.props.solutionAlias : this.props.fullName
      >
        <li
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) this.solutionSelected();
          }}
          onMouseDown={this.solutionSelected}
          onMouseUp={this.solutionUnselected}
          draggable
          onDragStart={(e) => {
            this.props.setSolutionHeld({
              id: this.props.id,
              held: true,
            });
            this.props.setHeldObject({
              id: this.props.id,
              type: "Solution",
              htmlObj: e.target,
            });
          }}
          onDragEnd={(e) => {
            this.props.setSolutionHeld({
              id: this.props.id,
              held: false,
            });
          }}
          id={"Solution_" + this.props.id}
          tabIndex={0}
          className={
            "Solution draggable dropTarget" + (this.props.open ? " open" : "")
          }
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}
        >
          <p
            className="label"
            aria-hidden="true"
            ref={(label) => {
              this.label = label;
            }}
          >
            {this.getLabel()}
          </p>
          <Graphics id={this.props.id} />
          <div
            className="move-menu"
            ref={(movemenu) => {
              this.movemenu = movemenu;
            }}
            style={{ display: this.props.controlsVisible ? null : "none" }}
          >
            <button
              tabIndex={0}
              className="move-button"
              onClick={this.showMoveMenu}
              aria-label="Move menu. Select to view the available positions."
            >
              <img src={WhiteHamburgerIcon} alt="Move menu icon." />
            </button>
            <MoveMenu type={this.props.type} connect={this.props.id} />
          </div>
        </li>
      </ul>
    );
  }
}
